'use client';

import GlowDivider from '@/components/ui/GlowDivider';

import {
  BarChart3,
  Briefcase,
  Shield,
  TrendingUp,
  Users,
  Zap
} from 'lucide-react';

const features = [
  {
    name: 'Advanced Analytics',
    description:
      'Powerful data analysis tools to understand biological market trends and emerging sectors.',
    icon: BarChart3,
    color: '#6A3C9E'
  },
  {
    name: 'Weekly Briefing',
    description:
      'A weekly email for biotech professionals, investors, and scientists who want the data behind the headlines.',
    icon: Users,
    color: '#4A7F38'
  },
  {
    name: 'Real-time Insights',
    description:
      'Get instant updates on market movements, funding rounds, and clinical milestones.',
    icon: Zap,
    color: '#066653'
  },
  {
    name: 'Growth Tracking',
    description:
      'Monitor sector growth metrics and pinpoint the most lucrative investment opportunities.',
    icon: TrendingUp,
    color: '#6A3C9E'
  },
  {
    name: 'Trusted Data',
    description:
      'Every chart is sourced from premium databases like PitchBook, Crunchbase, and PubMed.',
    icon: Shield,
    color: '#4A7F38'
  },
  {
    name: 'Enterprise Solutions',
    description:
      'Tailored internal reporting and co-branded data storytelling for large organizations.',
    icon: Briefcase,
    color: '#066653'
  }
];

export function LandingFeatures() {
  return (
    <section className='bg-background relative z-10 px-6 py-16 md:py-24'>
      <GlowDivider />
      <div className='mx-auto max-w-6xl'>
        <div className='mb-16 md:mx-auto md:max-w-2xl md:text-center'>
          <p className='text-secondary mb-3 text-[10px] font-black tracking-[0.35em] uppercase'>
            Capabilities
          </p>
          <h2 className='text-foreground mb-4 text-3xl leading-tight font-black tracking-tight md:text-4xl'>
            Everything you need to understand the biological revolution.
          </h2>
          <p className='text-muted-foreground text-base leading-relaxed md:text-lg'>
            Bioinfometrics is built for leaders who demand clarity. We distill
            massive datasets into actionable, beautiful insights.
          </p>
        </div>

        <div className='grid gap-6 sm:grid-cols-2 lg:grid-cols-3'>
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.name}
                className='group border-border/40 bg-card hover:shadow-primary/5 relative flex flex-col rounded-2xl border p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg'>
                <div
                  className='mb-6 flex size-12 items-center justify-center rounded-xl transition-transform duration-300 group-hover:scale-110'
                  style={{ background: `${feature.color}15` }}>
                  <Icon
                    className='size-5'
                    style={{ color: feature.color }}
                    strokeWidth={2}
                  />
                </div>

                <h3 className='text-foreground mb-2 text-lg font-bold'>
                  {feature.name}
                </h3>
                <p className='text-muted-foreground flex-1 text-[14px] leading-relaxed'>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
